import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import projImg1 from "../assets/img/project-img1.png";
import projImg2 from "../assets/img/project-img2.png";
import projImg3 from "../assets/img/project-img3.png";
import projImg4 from "../assets/img/project-img4.PNG";
import projImg5 from "../assets/img/project-img5.PNG";
import projImg6 from "../assets/img/project-img6.PNG";
import colorSharp2 from "../assets/img/color-sharp2.png";
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Projects = () => {

  const projects = [
    {
      title: "Business Startup",
      description: "Design & Development",
      imgUrl: projImg1,
    },
    {
      title: "Netflix Clone",
      description: "API JS Front-end",
      imgUrl: projImg2,
    },
    {
      title: "Todo-App",
      description: "React Development",
      imgUrl: projImg3,
    },
    {
      title: "Tip Calculator",
      description: "Javascript",
      imgUrl: projImg4,
    },
    {
      title: "Weather-App",
      description: "JS & API Development",
      imgUrl: projImg5,
    },
    {
      title: "Fighting Game",
      description: "JS Based Game",
      imgUrl: projImg6,
    },
    
  ];

  return (
    <section className="project" id="project">
      <Container>
        <Row>
          <Col size={12}>
          <TrackVisibility>
                    {
                    ({isVisible})=>
                    <div className={isVisible?"animate__animated animate__slideInUp":""}>
                <h2>Projects</h2>
                <p>Examples Of My Projects</p>
                </div>}
                </TrackVisibility>
                <Tab.Container id="projects-tabs" defaultActiveKey="first">
                  <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                    <Nav.Item>
                      <Nav.Link eventKey="first">Tab 1</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="second">Tab 2</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="third">Tab 3</Nav.Link>
                    </Nav.Item>
                  </Nav>
                  <Tab.Content>
                    <Tab.Pane eventKey="first">
                      <Row>
                        {
                          projects.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                      </Row>
                    </Tab.Pane>
                
                    <Tab.Pane eventKey="second">
                      <p>Adding Soon.</p>
                    </Tab.Pane>
                    <Tab.Pane eventKey="third">
                      <p>Adding Soon.</p>
                    </Tab.Pane>
                    

                  </Tab.Content>
                </Tab.Container>
              
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2}></img>
    </section>
  )
}